<template>
   <loading-container :state="state" :i18nErrorMessage="getI18nErrorString()" :error-uuid="errorUuid" >
              <!-- load with type="search" or type="home" or type="overlay" -->

    <Suche v-if="lookUpValuesTopic"
      :topics="lookUpValuesTopic"
      :regions="regions"
      :messages="searchMessages"
      :type="type"
      :selectedTopicsProp="selectedTopics"
      :selectedRegionProp="selectedRegion"
      :selectedLong="selectedLong"
      :selectedLat="selectedLat"
      @submit="getEmit"
    />
  </loading-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Suche from '@/components/ergebnisliste/Suche.vue'
import { mapActions } from "vuex";
import LoadingMixin from "../mixins/LoadingMixin";
import { LoadingState } from "../utils/loadingUtils";
import { LookupValueDto, RegionDto } from "@/generated/openapi/api";
import LoadingContainer from '@/components/structure/LoadingContainer.vue';

export default defineComponent({
  name: "WidgetBeratungsSuche",
  components:{
    LoadingContainer,
    Suche
  },
  mixins: [
    LoadingMixin
  ],
  emits: ['submit'],
  methods: {
    ...mapActions(['getAllLookUpValuesTopic', 'getAllRegions']),
    getEmit(...value: any){
      this.$emit('submit', value[0], value[1], value[2], value[3]);
    }
  },
  data() {
    return {
      searchMessages: Object
    }
  },
  props: {
    messages: String,
    type: String,
    selectedRegion: String,
    selectedLong: String,
    selectedLat: String,
    selectedTopics: Array,
  },
  computed: {
    lookUpValuesTopic(): Array<LookupValueDto> {
      if (this.$store.state.allLookUpValuesTopic) {
        return this.$store.state.allLookUpValuesTopic.get('topic')
      }
      return []
    },
    regions(): Array<RegionDto> {
      if (this.$store.state.regions) {
        return this.$store.state.regions
      }
      return []
    }
  },
  mounted() {

    if (this.messages) {
      this.searchMessages = Object.assign({}, JSON.parse(this.messages))
    }

    this.state = LoadingState.loading
    this.getAllLookUpValuesTopic().then(_ => {
      this.getAllRegions().then(_ => {
        this.state = LoadingState.success
      }).catch(_ => {
        this.state = LoadingState.error
      })
      // this.state = LoadingState.success
    }).catch(_ => {
      this.state = LoadingState.error
    })
  }
})
</script>

<style scoped>

</style>
